import React, { PureComponent, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import CollapsableHeader from 'components/collapsable_header/collapsable_header'
import { StudentGrid, TilesModal, WellDone } from '../components'
import CountdownStudent from 'views/countdown/countdown_student/countdown_student'
import TimerDecorator from 'decorators/timer/timer_decorator'
import sessionTypes from 'helpers/enums/sessionTypes'
import TimerCountdown from 'views/countdown/countdown_timer/countdown_timer'
import ImmersiveReaderButton from 'components/immersive_reader_button/immersive_reader_button'

import styles from './view.scss'

class MatchingPairsStudentView extends PureComponent {

	constructor(props) {
		super(props)

		const tiles = this.createTiles(props.activityData.pairs)

		this.state = {
			expandedHeader: props.should_expand_header_on_start,
			preview: {
				visible: false,
				tiles: [],
			},
			wellDoneVisible: false,
			activate: false,
			tiles,
			attempts: 0,
			matched: 0,
			currentTile: -1,
			currentHighlightedPair: [],
			currentPair: [],
		}

		this.toggleHeader = this.toggleHeader.bind(this)
		this.closeHeader = this.closeHeader.bind(this)
		this.closeWellDoneHandler = this.closeWellDoneHandler.bind(this)
		this.closePreview = this.closePreview.bind(this)
		this.tileClickHandler = this.tileClickHandler.bind(this)
		this.tileZoomClickHandler = this.tileZoomClickHandler.bind(this)
		this.tileLoaded = this.tileLoaded.bind(this)

		this.currentStatusTimeout = null
		this.loadedTiles = 0
	}

	tileClickHandler(index) {
		const clickedTile = this.state.tiles[index]
		if (clickedTile.status === 'success' || clickedTile.status === 'matched') {
			if (this.state.currentTile === -1) {
				this.showCompletedPair(index)
			}
		} else {
			if (this.state.currentTile === -1) {
				this.handleSelectedFirstItem(index)
			} else if (this.state.currentTile === index) {
				this.setState({
					currentTile: -1,
					tiles: this.updateTileStatus(this.state.tiles, index, 'idle'),
				})
			} else {
				this.checkPair(index)
			}
		}
	}

	tileZoomClickHandler(index) {
		this.setState({
			preview: {
				visible: true,
				tiles: [index],
			},
		})
	}

	showCompletedPair(clickedTileIndex) {
		const pairId = this.state.tiles[clickedTileIndex].id
		const clickedTileMatchIindex = this.state.tiles.findIndex((tile, i) => tile.id === pairId && i !== clickedTileIndex)
		this.setState({
			preview: {
				visible: true,
				tiles: [clickedTileIndex, clickedTileMatchIindex],
			},
		})
	}

	closePreview() {
		this.setState({
			preview: {
				...this.state.preview,
				visible: false,
			},
		})
	}

	createTiles(pairs) {
		const pairsLength = pairs.length * 2
		const order = this.shuffleArray(pairsLength)
		return order.map(function(index) {
			const pairIndex = Math.floor(index / 2)
			const isFirstCard = index / 2 - pairIndex === 0
			const pair = pairs[pairIndex]
			const display = pair[isFirstCard ? 'card1' : 'card2']
			return {
				id: pair.id,
				status: 'idle',
				display,

			}
		})

	}

	shuffleArray(_length) {
		const array = []
		let i = 0
		for (i = 0; i < _length; i += 1) {
			array[i] = i
		}
		var tmp, current, top = array.length
		if (top) while (--top) {
			current = Math.floor(Math.random() * (top + 1))
			tmp = array[current]
			array[current] = array[top]
			array[top] = tmp
		}
		return array
	}

	toggleHeader() {
		this.setState({ expandedHeader: !this.state.expandedHeader })
	}

	closeHeader() {
		this.setState({ expandedHeader: false })
	}

	closeWellDoneHandler() {
		this.setState({ wellDoneVisible: false })
	}

	updateTileStatus(tiles, index, status) {
		const updatedTile = {...tiles[index], ...{status}}
		return [...tiles.slice(0, index), updatedTile, ...tiles.slice(index + 1)]

	}

	handleMatchAction(index1, index2, status) {

		const updatedTile1 = {...this.state.tiles[index1], ...{status}}
		const updatedTile2 = {...this.state.tiles[index2], ...{status}}
		const tiles = this.state.tiles.map(function(tile, index) {
			if (index === index1) {
				return updatedTile1
			} else if (index === index2) {
				return updatedTile2
			} else {
				return tile
			}
		})
		return tiles
	}

	handleMatchSuccess(index1, index2) {
		const tiles = this.handleMatchAction(index1, index2, 'success')
		this.setState({
			tiles,
			currentTile: -1,
			attempts: this.state.attempts + 1,
			matched: this.state.matched + 1,
			currentPair: [this.state.tiles[index1], this.state.tiles[index2]],
		})
		this.resetHighlightedPair(index1, index2, 'matched')
	}

	handleMatchError(index1, index2) {
		const tiles = this.handleMatchAction(index1, index2, 'error')
		this.setState({
			tiles,
			currentTile: -1,
			currentHighlightedPair: [index1, index2],
			attempts: this.state.attempts + 1,
			currentPair: [this.state.tiles[index1], this.state.tiles[index2]],
		})
		this.currentStatusTimeout = this.resetHighlightedPair(index1, index2, 'idle')
	}

	resetHighlightedPair(index1, index2, status) {
		return setTimeout(() => {
			const tiles = this.handleMatchAction(index1, index2, status)
			this.setState({
				tiles,
				currentHighlightedPair: [],
			})
			this.currentStatusTimeout = null
		}, 4000)
	}

	resetCurrentHighlightedPair() {
		clearTimeout(this.currentStatusTimeout)
		this.currentStatusTimeout = null
		const index1 = this.state.currentHighlightedPair[0]
		const index2 = this.state.currentHighlightedPair[1]
		return this.handleMatchAction(index1, index2, 'idle')
	}

	checkPair(index) {
		const tile1 = this.state.tiles[this.state.currentTile]
		const tile2 = this.state.tiles[index]
		if (tile1.id === tile2.id) {
			this.handleMatchSuccess(this.state.currentTile, index)
		} else {
			this.handleMatchError(this.state.currentTile, index)
		}
	}

	handleSelectedFirstItem(index) {
		//Resetting error state from previous pair
		let tiles = this.state.tiles
		if (this.state.currentHighlightedPair.length) {
			tiles = this.resetCurrentHighlightedPair(tiles)
		}
		tiles = this.updateTileStatus(tiles, index, 'selected')
		this.setState({
			currentTile: index,
			currentHighlightedPair: [],
			tiles,
		})
	}

	selectPreviewTiles() {
		return this.state.preview.tiles.map(tileIndex => this.state.tiles[tileIndex])
	}

	tileLoaded() {

		this.loadedTiles += 1
		if (this.state.tiles.length === this.loadedTiles) {
			this.setState({
				activate: true,
			})
			this.props.onActivityLoaded()
		}

	}

	endActivity = () => {
		setTimeout(() => {
			this.setState({ wellDoneVisible: true })
		}, 1500)
		if (this.props.sessionType !== sessionTypes.TEACHER_STUDENT_VIEW) {
			this.props.onEnd(this.state.attempts, this.state.matched, this.state.currentPair)
		}
	}

	immersiveReaderInstructionsTransform = () => {
		this.props.onImmersiveReaderTransform(
			this.props.activityData.instructions
		)
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.matched !== this.state.matched && this.state.matched === this.props.activityData.pairs.length) {
			this.endActivity()
		} else if (prevState.attempts !== this.state.attempts && this.props.sessionType !== sessionTypes.TEACHER_STUDENT_VIEW) {
			this.props.onNewAttempt(this.state.attempts, this.state.matched, this.state.currentPair)
		} else if (prevState.activate !== this.state.activate && !this.props.should_expand_header_on_start) {
			setTimeout(() => {
				this.setState({
					expandedHeader: true,
				})
			}, 1500)
		}
	}

	render() {
		const shouldShowCountdownTimer = this.props.timerData
			&& this.props.timerData.timer
			&& this.props.timerData.timer.active !== '0'

		const shouldShowTimerPill = this.props.timerData
			&& this.props.timerData.timer
			&& this.props.timerData.timer.state

		return (
			<Fragment>
				<div styleName="StudentView">
					{ shouldShowTimerPill &&
					<div styleName="timer">
						<TimerCountdown
							timer={this.props.timerData.timer}
							onComplete={this.props.timerData.onTimerComplete}
							canStart={this.props.timerData.can_start_timer}
						/>
					</div>
					}
					<div styleName='top-bar'></div>
					<main styleName='content'>
						{this.props.activityData.instructions &&
					<CollapsableHeader
						onCollapsableClick={this.closeHeader}
						expanded={this.state.expandedHeader}
						onToggle={this.toggleHeader}
						shouldOffsetCollapsableHeaderButton={this.props.shouldOffsetCollapsableHeaderButton}
						hasRightPadding={true}
					>
						{ this.props.shouldShowImmersiveReader &&
							<div styleName='content-immersive-reader'>
								<ImmersiveReaderButton
									onClickHandler={this.immersiveReaderInstructionsTransform}
								/>
							</div>
						}
						<h1 styleName="content-title">
							{this.props.activityData.instructions}
						</h1>
					</CollapsableHeader>}
						<div styleName='content-grid' style={{padding: this.props.grid_paddings}}
							onClick={this.state.expandedHeader ? this.closeHeader : null}>
							<StudentGrid
								tileLoadedHandler={this.tileLoaded}
								tiles={this.state.tiles}
								activate={this.state.activate}
								assetsPath={this.props.assetsPath}
								should_animate_cards={this.props.should_animate_cards}
								tileClickHandler={this.tileClickHandler}
								tileZoomClickHandler={this.tileZoomClickHandler}
								resize={this.props.resize}
							/>
						</div>
						{this.state.preview.visible &&
						<TilesModal
							resize={this.props.resize}
							tiles={this.selectPreviewTiles()}
							closeHandler={this.closePreview}
							shouldShowImmersiveReader={this.props.shouldShowImmersiveReader}
							onImmersiveReaderTransform={
								this.props.onImmersiveReaderTransform
							}
						/>
						}
					</main>
				</div>
				{ this.state.wellDoneVisible &&
				<WellDone
					title={localize('matching_pairs_well_done')}
					attempts={this.state.attempts}
					text={this.props.sessionType === sessionTypes.HOMEWORK
						? localize('matching_pairs_student_complete')
						: localize('matching_pairs_student_wait')
					}
					buttonText={this.props.sessionType === sessionTypes.HOMEWORK
						? localize('matching_pairs_homework_student_confirm')
						: localize('matching_pairs_student_confirm')
					}
					buttonHandler={this.closeWellDoneHandler}
					closeHandler={this.closeWellDoneHandler}
				/>
				}

				{shouldShowCountdownTimer &&
		<CountdownStudent
			{...this.props.timerData}
			activityName={`${localize('matchingPairs_timeForMatchingPairs2')}!`}
		/>}
			</Fragment>
		)
	}
}

MatchingPairsStudentView.defaultProps = {
	onEnd: () => {},
	onNewAttempt: () => {},
	onActivityLoaded: () => {},
	assetsPath: '/assets/media/',
	should_animate_cards: true,
	should_expand_header_on_start: false,
	shouldOffsetCollapsableHeaderButton: false,
	onImmersiveReaderTransform: () => {},
	shouldShowImmersiveReader: false,
}

MatchingPairsStudentView.propTypes = {
	onEnd: PropTypes.func,
	onNewAttempt: PropTypes.func,
	onActivityLoaded: PropTypes.func,
	assetsPath: PropTypes.string,
	should_animate_cards: PropTypes.bool,
	should_expand_header_on_start: PropTypes.bool,
	shouldOffsetCollapsableHeaderButton: PropTypes.bool,
	onImmersiveReaderTransform: PropTypes.func,
	shouldShowImmersiveReader: PropTypes.bool,
}

export default TimerDecorator(
	CSSModules(MatchingPairsStudentView, styles, { allowMultiple: true })
)

export { MatchingPairsStudentView }
